import React from 'react';

// Open-Meteo weathercode groups → asset. https://open-meteo.com/en/docs (WMO codes)
const CLEAR_CODES = [0, 1];
const PARTLY_CLOUDY_CODES = [2];
const OVERCAST_CODES = [3, 45, 48];
const PRECIPITATION_CODES = [
  51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 71, 73, 75, 77, 80, 81, 82, 85, 86,
  95, 96, 99,
];

export function getWeatherVideoSrc(weathercode, isDay) {
  if (weathercode == null) return null;
  if (CLEAR_CODES.includes(weathercode)) {
    return isDay ? '/videos/sunny.mp4' : '/videos/night.mp4';
  }
  if (PARTLY_CLOUDY_CODES.includes(weathercode))
    return '/videos/partly_cloudy.mp4';
  if (OVERCAST_CODES.includes(weathercode)) return '/videos/cloudy.mp4';
  if (PRECIPITATION_CODES.includes(weathercode)) return '/videos/rainy.mp4';
  return isDay ? '/videos/sunny.mp4' : '/videos/night.mp4';
}

function VideoBackground({ src, className = '' }) {
  if (!src) return null;
  return (
    <video
      key={src}
      autoPlay
      loop
      muted
      playsInline
      className={`pointer-events-none absolute inset-0 h-full w-full object-cover ${className}`}
      // Dimmed so it stays a subtle ambient backdrop rather than competing
      // with the text/UI laid over it.
      style={{ filter: 'brightness(0.65) saturate(0.9)' }}
    >
      <source src={src} type="video/mp4" />
    </video>
  );
}

export default VideoBackground;
